module.exports = __webpack_public_path__ + "static/UBCLaunchPad-Info-light-f7f6fd2577a9b263463195471796a07c.svg";